/* @ngInject */
const myPieceForm = () => {
  return {
    restrict: 'E',
    scope: {
      piece: '=myPiece',
      index: '=myIndex',
      enableValidator: '=?',
    },
    template: require('./myPieceForm.html'),
    /* @ngInject */
    controller: ($scope, $$piece) => {
      $scope.fieldsOptions = $$piece.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myPieceForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/directives/forms/myPieceForm.js